import { render, staticRenderFns } from "./bankwallet.vue?vue&type=template&id=58ce11a8&scoped=true"
import script from "./bankwallet.vue?vue&type=script&lang=js"
export * from "./bankwallet.vue?vue&type=script&lang=js"
import style0 from "./bankwallet.vue?vue&type=style&index=0&id=58ce11a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce11a8",
  null
  
)

export default component.exports